import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  AdminChangelogEntry,
  useUpdateChangelog,
} from "@/lib/api/changelog";
import { ChangelogForm } from "./changelog-form";

interface EditChangelogDialogProps {
  entry: AdminChangelogEntry | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EditChangelogDialog({
  entry,
  open,
  onOpenChange,
}: EditChangelogDialogProps) {
  const { mutateAsync, isPending } = useUpdateChangelog();

  if (!entry) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit changelog: {entry.title}</DialogTitle>
        </DialogHeader>
        <ChangelogForm
          key={entry.id}
          submitLabel="Save changes"
          isSubmitting={isPending}
          defaultValues={{
            title: entry.title,
            subtitle: entry.subtitle ?? "",
            date_label: entry.date_label ?? "",
            body: entry.body,
            changes: entry.changes,
            loom_url: entry.loom_url ?? "",
            role_ids: entry.role_ids,
          }}
          onCancel={() => onOpenChange(false)}
          onSubmit={async (values) => {
            await mutateAsync({ id: entry.id, ...values });
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
